import { AVATAR_SIZE_RECORD } from '../constants/size.mjs';

function getRelativeSizeRange(avatarSize) {
  switch (true) {
    case avatarSize >= AVATAR_SIZE_RECORD.xlarge:
      return "xlarge";
    case avatarSize >= AVATAR_SIZE_RECORD.large:
      return "large";
    case avatarSize >= AVATAR_SIZE_RECORD.default:
      return "default";
    case avatarSize >= AVATAR_SIZE_RECORD.small:
      return "small";
    case avatarSize < AVATAR_SIZE_RECORD.small:
      return "xsmall";
    default:
      return "default";
  }
}

export { getRelativeSizeRange };
//# sourceMappingURL=size.mjs.map
